import { CSRF } from '../utils/CSRF'
import { BaseRepository } from './BaseRepository'

export interface TeamPhoneme {
  id: number
  alphabet: 'ipa'
  pair_spelling: string
  pair_content: string
}

export class PhonemeRepository extends BaseRepository {
  addPhoneme(team: string, alphabet: string, text: string, phoneme: string) {
    return super.getHttpClientInstance().post(
      `/teams/${team}/phonemes.json`,
      {
        alphabet: alphabet,
        pair_spelling: phoneme,
        pair_content: text,
      },
      {
        'X-CSRF-Token': CSRF.getToken(),
      },
    )
  }

  deletePhoneme(team: string, phonemeId: number | string) {
    return super.getHttpClientInstance().delete(`/teams/${team}/phonemes/${phonemeId}.json`, {
      'X-CSRF-Token': CSRF.getToken(),
    })
  }

  getPhonemes(team: string) {
    return super.getHttpClientInstance().get(`/teams/${encodeURIComponent(team)}/phonemes.json`)
  }

  getTeamPhonemes(team: string) {
    return super.getHttpClientInstance().get<TeamPhoneme[]>(`/teams/${encodeURIComponent(team)}/phonemes.json`)
  }

  generatePhoneme(team: string, text: string, language: string) {
    return super.getHttpClientInstance().get<{ phoneme: string }>(
      `/teams/${encodeURIComponent(team)}/phonemes/generate?${new URLSearchParams({
        text,
        language,
      }).toString()}`,
    )
  }

  createTeamPhoneme(team: string, word: string, ipa: string) {
    return super.getHttpClientInstance().post<TeamPhoneme>(
      `/teams/${encodeURIComponent(team)}/phonemes.json`,
      {
        alphabet: 'ipa',
        pair_spelling: word,
        pair_content: ipa,
      },
      {
        'X-CSRF-Token': CSRF.getToken(),
      },
    )
  }

  async generateTeamPhoneme(team: string, text: string, language: string): Promise<string> {
    const response = await this.generatePhoneme(team, text, language)
    return response.data.phoneme
  }
}
